import { createSelector } from 'reselect';

const getValidateSerialNumber = ({ powertrainTools }) => {
    return powertrainTools?.serialNumberEditor?.validateSerialNumber;
};


export const getModel = createSelector(
    [
        getValidateSerialNumber
    ],
    (
        validateSerialNumber
    ) => {
        return {
            validateSerialNumber
        };
    }
);
